import { DrawingAppliance, DrawingShape } from '~/core/models';

export const getActiveDrawingObjectName = ({
  activeDrawingApplianceId,
  activeDrawingAppliance,
  activeDrawingShape,
}: {
  activeDrawingApplianceId: string | undefined;
  activeDrawingAppliance: DrawingAppliance | undefined;
  activeDrawingShape: DrawingShape | undefined;
}): string =>
  activeDrawingApplianceId
    ? // Uses ?? (not ||) to match findAppliedApplianceName: an empty-string consumerDesc is returned as-is, mirroring the dispatch path.
      (activeDrawingAppliance?.applianceModel.consumerDesc ??
      activeDrawingAppliance?.applianceModel.name ??
      '')
    : (activeDrawingShape?.label ?? '');
